export enum SortType {
  ASC = 0,
  DESC = 1,
}
